import { render, staticRenderFns } from "./bindtel.vue?vue&type=template&id=2a15d20b&scoped=true"
import script from "./bindtel.vue?vue&type=script&lang=js"
export * from "./bindtel.vue?vue&type=script&lang=js"
import style0 from "./bindtel.vue?vue&type=style&index=0&id=2a15d20b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a15d20b",
  null
  
)

export default component.exports